import { TextInput, Typography } from "@strapi/design-system";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import UploadFile from "../uploadFile";
import { DatePicker } from "antd";
import dayjs from "dayjs";

const CommercializationMission = ({ data, setData }) => {
  const { t } = useTranslation();
  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    if (data?.attachment) {
      let item = null;

      if (data?.attachment?.id) {
        item = {
          uid: data?.attachment?.id,
          name: data?.attachment?.name,
          url: data?.attachment?.url,
          status: "done",
        };
      } else {
        let uploadedImages = [];
        if (localStorage.getItem("uploaded_images")) {
          uploadedImages = JSON.parse(localStorage.getItem("uploaded_images"));
        }

        if (uploadedImages.length > 0) {
          const img = uploadedImages.find((x) => x.id === data?.attachment);

          if (img) {
            item = {
              uid: img.id,
              name: img.name,
              url: img.url,
              status: "done",
            };
          } else {
            item = {
              uid: data?.attachment,
              name: data?.attachment?.name || "New File",
              url: data?.attachment?.url,
              status: "done",
            };
          }
        } else {
          item = {
            uid: data?.attachment,
            name: data?.attachment?.name || "New File",
            url: data?.attachment?.url,
            status: "done",
          };
        }
      }

      setFileList([item]);
    } else {
      setFileList([]);
    }
  }, [data?.attachment]);

  const handleSetName = (name) => {
    setData({ ...data, name });
  };

  const handleSetAuthorName = (author_name) => {
    setData({ ...data, author_name });
  };

  const handleSetYear = (date, dateString) => {
    setData({ ...data, year: dateString });
  };

  const handleSetNote = (note) => {
    setData({ ...data, note });
  };

  const handleSetForm = (form) => {
    setData({ ...data, form });
  };

  const handleSetUrl = (url) => {
    setData({ ...data, url });
  };

  const handleChangeAttachment = (resFile) => {
    setData({
      ...data,
      attachment: resFile?.id,
    });
  };

  const handleRemoveAttachment = (id) => {
    setData({
      ...data,
      attachment: null,
    });
  };

  return (
    <div>
      <TextInput
        label={t("str_product_name")}
        name="name"
        onChange={(e) => handleSetName(e.target.value)}
        value={data?.name || ""}
      />
      <br />
      <TextInput
        label={t("str_book_author_co_author")}
        name="author_name"
        onChange={(e) => handleSetAuthorName(e.target.value)}
        value={data?.author_name || ""}
      />
      <br />
      <TextInput
        label={t("str_application_format")}
        name="form"
        onChange={(e) => handleSetForm(e.target.value)}
        value={data?.form || ""}
      />
      <br />
      <Typography variant="pi" fontWeight="bold">
        {t("str_year_of_implementation")}
      </Typography>
      <br />
      <DatePicker
        onChange={handleSetYear}
        picker="year"
        value={data?.year ? dayjs().year(data?.year) : null}
        className="custom-date-picker"
      />
      <br />
      <TextInput
        label={t("str_note")}
        name="note"
        onChange={(e) => handleSetNote(e.target.value)}
        value={data?.note || ""}
      />
      {/* Đính kèm */}
      <br />
      <TextInput
        label={t("str_attach_proof")}
        name="url"
        onChange={(e) => handleSetUrl(e.target.value)}
        value={data?.url || ""}
      />
      <br />
      <Typography variant="pi" fontWeight="bold">
        {t("str_or_and")}
      </Typography>
      <br />
      <span className="subnotes">{t("str_only_pdf")}</span>
      <br />
      <UploadFile
        fileMimeType={["application/pdf"]}
        fileTypeAllowNames="pdf"
        handleUploadSuccess={handleChangeAttachment}
        fileList={fileList}
        handleRemoveFile={handleRemoveAttachment}
        accept="application/pdf"
      />
    </div>
  );
};

export default CommercializationMission;
